
export enum SuggestItemTypeEnum {
    NewBuilding = 'SuggestItemNewBuilding',
    Metro = 'SuggestItemMetro',
    District = 'SuggestItemDistrict',
    Address = 'SuggestItemAddress',
    Developer = 'SuggestItemDeveloper',
    Default = 'SuggestItemDefault'
}
